import PropTypes from 'prop-types';

export const captionsType = {
  preview: PropTypes.string.isRequired,
  startEditing: PropTypes.string.isRequired,
};

export const ACTIONS_TYPES = {
  floating: 'floating',
  content: 'content',
};
